import { PayloadAction } from '@reduxjs/toolkit';
import { localStorageEnum } from 'types';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { seasonSaga } from './saga';
import { ISeason, SeasonState } from './types';

export const initialState: SeasonState = {
  seasons: null,
  selectedSeasonId: null,
};

const slice = createSlice({
  name: 'season',
  initialState,
  reducers: {
    getSeasons(state, action: PayloadAction<number>) {},
    setSeasons(
      state,
      action: PayloadAction<{
        seasons: ISeason[];
        selectedSeasonId: number | null;
      }>,
    ) {
      const { seasons, selectedSeasonId } = action.payload;
      state.seasons = seasons;
      state.selectedSeasonId = selectedSeasonId;
    },
    setSelectedSeason(state, action: PayloadAction<number | null>) {
      if (action.payload) {
        localStorage.setItem(localStorageEnum.seasonId, String(action.payload));
      }
      state.selectedSeasonId = action.payload;
    },
  },
});

export const { actions: seasonActions } = slice;

export const useSeasonSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: seasonSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSeasonSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
